<template>
  <div class="lc">
    <div class="lt-left">
    </div>
    <div ref="cmain1" class="cmain" @mouseover="autoTimePaused = true" @mouseout="autoTimePaused = false"></div>
  </div>
</template>

<script>
import * as methods from './method.js'

export default {
  name: 'template.scope2',
  props: {
    vdata: {
      type: [Array, String],
      default: () => []
    },
    jsondata: {
      type: [Array, String],
      default: () => []
    },
    scopedata: {
      type: Object,
      default: () => { }
    }
  },
  data() {
    return {
      timer: null,
      defaultdata: [
        { value1: '系列一', value2: '1700' },
        { value1: '系列二', value2: '580' },
        { value1: '系列三', value2: '1800' },
      ],
      valueMap: [
        { name: '名称', key: "value1" },
        { name: '数值', key: "value2" },
      ],
      exceldata: [],
      apiconfig: {},
      isApi: false,
      scope: {},
      autoTimePaused: false
    }
  },
  beforeDestroy() {
    clearInterval(this.timer);
    this.timer = null
  },
  watch: {
    vdata(n) {
      if (n && n.length) {
        let vdatalist = n.filter(item => {
          let vlist = Object.keys(item)
          let isdata = false
          vlist.forEach(del => {
            if (item[del] == undefined) {
              item[del] = ''
            } else if (del && item[del]) {
              isdata = true
            }
          })
          if (vlist.length && isdata) return item
        })
        this.defaultdata = vdatalist
        this.cDrawCircle()
      }
    },
    jsondata(n) {
      this.exceldata = n
    }
  },
  methods: {
    ...methods,
    cDrawCircle() {
      clearInterval(this.timer)
      this.timer = null
      var echarts = require('echarts');
      var TmyChart = echarts.init(this.$refs.cmain1);
      const colorList = ['#004cc8', '#fff', '#00d9ff']
      let vdata = JSON.parse(JSON.stringify(this.defaultdata))
      if (vdata.length > 5) {
        vdata = vdata.slice(0, 5)
        this.$message('该饼图最多支持五组数据，超出部分已隐藏')
      }
      let data = vdata.map((item, i) => {
        if (item.value1 && (item.value2 || item.value2 == 0)) {
          return {
            name: item.value1,
            value: +item.value2,
            itemStyle: {
              color: colorList[i]
            }
          }
        }
      })
      let total = 0
      data.forEach(item => {
        if (item && item.value) {
          total += item.value
        }
      })
      var Toption = {
        tooltip: {
          trigger: 'item'
        },
        legend: {
          orient: 'vertical',  //文字 行 排放 默认列
          top: 'middle',
          right: 20,
          itemHeight: 15,    //图例的高度  文字左边那个
          itemWidth: 15,
          z: 5,
          textStyle: {
            //设置文本样式
            color: "#CBD8DE",
            lineHeight: 32,
            fontWeight: '400',
            fontSize: '14',
            // padding: [0, 0, 0, 10],
            rich: {
              a: {
                width: 60,
                padding: [0, -10, 0, 10],
                fontSize: 14,
              },
              b: {
                padding: [0, 0, 0, 28],
                fontSize: 14,
                color: '#00D9FF'
              },
            }

          },         //图例的高度
          formatter: function (name) {
            let newName = name.length > 4 ? name.slice(0, 4) + '...' : name;
            const format = data.find(item => item.name == name)
            let percent = (format.value / total * 100).toFixed(2)
            let arr = [
              '{a|' + newName + '}',
              '{b|' + percent + '%}',
            ]
            return arr.join("    ")
          }
        },
        series: [
          {
            type: 'pie',
            //选中ple的中间40-50
            center: ['28%', '52%'],
            radius: ['55%', '68%'],
            label: {
              show: false,
              position: 'center'
            },
            itemStyle: {
              normal: {
                borderColor: '#000',
                borderWidth: 2,
              }
            },
            data: data,
          }
        ]
      };
      Toption && TmyChart.setOption(Toption);
      this.timer = setInterval(function () {
        if (this.autoTimePaused) return; // 如果定时器暂停，则不执行后续逻辑
        TmyChart.clear();
        Toption && TmyChart.setOption(Toption);
      }, 5000)
    },
  },
  mounted() {
    if (this.vdata && this.vdata.length) {
      this.defaultdata = this.vdata
    }
    if (this.jsondata && this.jsondata.length) {
      this.exceldata = this.jsondata
    }
    this.setData()
    this.cDrawCircle()
  },
};
</script>

<style scoped lang="scss">
.lc {
  width: 435px;
  height: 240px;
  display: flex;
  position: relative;
  padding: 10px 0;
}

.lt-left {
  width: 190px;
  height: 158px;
  position: absolute;
  left: calc(50% - 190px);
  top: calc(50% - 75px);
  box-sizing: border-box;
  background: url('@/assets/template/piebg.png') no-repeat;
  background-size: 100%;
}

.cmain {
  width: 100%;
  height: 100%;
}
</style>